import { Company } from '@/api/CompanyApi';
import { BaseEntity } from '@/api/EntityApi';

export enum UserStatus {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	SUSPENDED = 'suspended',
}

export enum UserType {
	ADMIN = 'admin',
	USER = 'user',
}

export enum UserAccessLevel {
	LEVEL_0 = 'level_0',
	LEVEL_1 = 'level_1',
	LEVEL_2 = 'level_2',
}

interface BaseUser extends BaseEntity {
	firstName: string;
	lastName: string;
	phoneNumber: string;
	email: string;
	password: string;
	status: UserStatus;
	userType: UserType;
}

export interface User extends BaseUser {
	accessLevel: UserAccessLevel;
	company: Company;
	userType: UserType.USER;
}

export interface Admin extends BaseUser {
	userType: UserType.ADMIN;
}

export type AppUser = User;
